import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            token: JSON.parse(localStorage.getItem("vendor_token")),
            name: localStorage.getItem("vendor_name"),
            isPass: JSON.parse(localStorage.getItem("vendor_isPass")),
            id: JSON.parse(localStorage.getItem("vendor_id")),
            role: localStorage.getItem("vendor_role"),
        },
        loading: false,
        pad_size: 800,
        guide_option: { vendor_id: "" },
    },
    mutations: {
        setUserData(state, item) {
            localStorage.setItem("vendor_token", JSON.stringify(item.token));
            state.user.token = item.token;
            //承攬商
            for (let key in item) {
                if (key == "vendor") {
                    state.user.role = item.vendor.role;
                    state.user.name = item.vendor.vendor_chinese;
                    state.user.isPass = item.vendor.is_pass;
                    state.user.id = item.vendor.vendor_id;
                } else if (key == "manager") {
                    state.user.role = item.manager.role;
                    state.user.name = item.manager.department;
                    state.user.id = item.manager.manager_id;
                    state.user.isPass = 2;
                }
            }

            localStorage.setItem("vendor_name", state.user.name);
            localStorage.setItem(
                "vendor_isPass",
                JSON.stringify(state.user.isPass)
            );
            localStorage.setItem("vendor_id", JSON.stringify(state.user.id));
            localStorage.setItem("vendor_role", state.user.role);
        },
        removeToken(state) {
            state.user.token = "";
            localStorage.clear();
        },
        loadingAction(state, status) {
            state.loading = status;
        },
        setVendorID(state, data) {
          state.guide_option.vendor_id = data;
        },
    },
    actions: {
        loadingAction({ commit }) {
            commit("loadingAction");
        },
    },
    modules: {},
});
